// Українська — мова за замовчуванням, також джерело ключів для інших мов
const ua = {
    // загальне
    "common.loading": "Очікування відповіді...",

    // навбар та меню
    "nav.login": "Вхід",
    "nav.profile": "Профіль",
    "nav.logout": "Вийти з облікового запису",
    "nav.stats": "Статистика",
    "nav.topPlayers": "Топ гравців",
    "nav.leaders": "Лідери",
    "nav.shop": "Магазин",
    "nav.case": "Ящик",
    "nav.giveaways": "Розіграші",

    // банер
    "header.donateInfo": "При донаті від 1000грн – бонус до поповнення +10%. Це добровільні донати для розвитку проєкту, які не підлягають поверненню.",
    "header.bonus": "Ваш особистий бонус +{n}% 👍",
    "header.noBonus": "У вас поки немає особистого бонусу 😕",

    // вибір сервера
    "servers.title": "Виберіть тип серверу",
    "servers.text": "Від цього залежить які предмети доступні для покупки, на сервері <b>trio</b> доступні не всі предмети.",

    // футер
    "footer.agreement": "Угода користувача",
    "footer.privacy": "Політика конфіденційності",
    "footer.about": "Про нас",
    "footer.nav": "Розділи",
    "footer.info": "Інформація",
    "footer.tagline": "Сервери DayZ ASKOLD: магазин предметів, ящик удачі та щотижневі розіграші.",
    "footer.note": "Проєкт Askold",

    // товар
    "product.buy": "Купити",
    "product.loginSteam": "Увійти через Steam",
    "product.friendPlaceholder": "SteamId друга",
    "product.noServer": "Ви не обрали сервер покупки!",
    "product.noFriend": "Ви не вказали steamId свого друга!",
    "product.badSteamId": "Невірний SteamID: він має містити рівно 17 цифр!",
    "product.error": "Сталася помилка",
    "product.confirmBefore": "Ви точно хочете придбати",
    "product.confirmOnServer": "на сервер",
    "product.pickup": "Після придбання можете забрати на клавішу <b>\"u\"</b>",
    "product.yes": "Так",
    "product.cancel": "Скасувати",
    "product.color": "Колір",

    // статистика
    "stats.title": "Топ гравців",
    "stats.subtitle": "Найкращі гравці наших серверів за вбивствами, K/D та дальністю пострілу",
    "stats.kills": "Вбивства",
    "stats.killsLabel": "вбивств",
    "stats.kd": "K/D",
    "stats.distance": "Дальність",
    "stats.distanceLabel": "найдальший постріл",
    "stats.playtime": "Час у грі",
    "stats.playtimeLabel": "награно",
    "stats.deaths": "Смерті",
    "stats.farthest": "Найдальше",
    "stats.time": "Час",
    "stats.player": "Гравець",
    "stats.error": "Статистика тимчасово недоступна. Спробуйте пізніше.",
    "stats.empty": "Поки що немає даних.",
    "stats.hours": "год",
    "stats.minutes": "хв",
    "stats.meters": "м",

    // ящик удачі
    "case.title": "Ящик удачі",
    "banner.cta": "Відкрити ящик",
    "banner.shortPrice": "За {price} ₴",
    "banner.shortMax": "предмет до {max} ₴",
    "banner.gwCta": "Взяти участь",
    "banner.gwEnds": "Закінчиться через",
    "case.subtitle": "Відкрийте ящик і заберіть випадковий предмет з асортименту магазину. Виграш одразу потрапляє у ваш кошик.",
    "case.server": "Сервер видачі",
    "case.open": "Відкрити за {price} ₴",
    "case.opening": "Відкриваємо...",
    "case.login": "Увійдіть через Steam, щоб відкрити ящик",
    "case.noMoney": "Недостатньо коштів",
    "case.deposit": "Поповнити баланс",
    "case.contents": "Вміст ящика",
    "case.items": "{n} предметів",
    "case.chance": "Шанс",
    "case.empty": "Для цього сервера ящик поки порожній.",
    "case.error": "Не вдалося завантажити ящик. Спробуйте пізніше.",
    "case.disabled": "Ящик удачі зараз недоступний. Загляньте пізніше!",
    "case.openError": "Не вдалося відкрити ящик",
    "case.youWon": "Вам випало",
    "case.inBasket": "Предмет уже у вашому кошику на сервері {server}. Забрати його в грі можна на клавішу «U».",
    "case.toBasket": "До кошика",
    "case.again": "Відкрити ще",
    "case.return": "Повернути за {price} ₴",
    "case.returnHint": "Предмет з ящика повертається за 50% ціни",
    "case.returnError": "Не вдалося повернути предмет",
    "case.noRefund": "Предмет з ящика можна повернути за 50% ціни (крім пріоритету й сету). Чим дорожчий предмет, тим менший шанс.",
    "case.skip": "Пропустити",
    "case.rarity.legendary": "Легендарний",
    "case.rarity.epic": "Епічний",
    "case.rarity.rare": "Рідкісний",
    "case.rarity.uncommon": "Незвичайний",
    "case.rarity.common": "Звичайний",

    // розіграші
    "giveaways.title": "Розіграші",
    "giveaways.subtitle": "Щотижня розігруємо випадкові товари магазину. Переможця обирає сервер випадково, приз одразу потрапляє в кошик.",
    "giveaways.drawIn": "До підсумків",
    "giveaways.drawAt": "Щосуботи о 21:00",
    "giveaways.drawing": "Підбиваємо підсумки...",
    "giveaways.days": "д",
    "giveaways.seconds": "с",
    "giveaways.type.all": "Для всіх",
    "giveaways.type.priority": "Для власників пріоритету",
    "giveaways.type.set": "Для власників сету",
    "giveaways.rule.all": "Безкоштовно для всіх гравців — просто натисніть «Взяти участь»",
    "giveaways.rule.priority": "Беруть участь гравці з активним пріоритетом",
    "giveaways.rule.set": "Беруть участь гравці з активним сетом",
    "giveaways.worth": "вартістю {price} ₴",
    "giveaways.participants": "Учасників: {n}",
    "giveaways.beFirst": "Станьте першим учасником",
    "giveaways.server": "Сервер для призу",
    "giveaways.join": "Взяти участь",
    "giveaways.checking": "Записуємо...",
    "giveaways.joined": "Ви берете участь · {server}",
    "giveaways.joinedToast": "Ви берете участь у розіграші! Удачі 🍀",
    "giveaways.login": "Увійти через Steam",
    "giveaways.needPriority": "Потрібен активний пріоритет",
    "giveaways.needSet": "Потрібен активний сет",
    "giveaways.toShop": "До магазину",
    "giveaways.error": "Не вдалося завантажити розіграші. Спробуйте пізніше.",
    "giveaways.joinError": "Не вдалося взяти участь",
    "giveaways.empty": "Розіграші скоро з'являться.",
    "giveaways.winners": "Останні переможці",
    "giveaways.noWinners": "Переможців ще немає — станьте першим!",
    "giveaways.of": "з {n}",
} as const;

export type TranslationKey = keyof typeof ua;
export default ua;
